import React from 'react';
import * as styles from './feature-icon.style';
import { jsx as ___EmotionJSX } from "@emotion/core";
var FeatureIcon = _ref => {
  var value = _ref.value,
    Icon = _ref.icon;
  return value ? ___EmotionJSX("div", {
    css: styles.feature
  }, ___EmotionJSX(Icon, {
    size: "small"
  }), ___EmotionJSX("span", {
    css: styles.number
  }, value)) : null;
};
export default FeatureIcon;